<div class="inner-page-wrapper pt-24 md:py-40">
    @for (department of teams(); track department) {
        <details class="group" #team [id]="department.slug" [open]="department.slug === initialOpenSlug()">
            <summary
                class="border-grey-200 flex w-full cursor-pointer items-center justify-between border-b-2 py-24 pr-16 pl-24"
            >
                <span
                    class="font-headline text-18 md:text-22 md:text-accent leading-27 font-medium text-black md:leading-28"
                >
                    {{ department.label }}
                </span>
                <i
                    class="icon-chevron-down text-16 text-accent transition-all group-open:rotate-180"
                    aria-hidden="true"
                ></i>
            </summary>

            <div
                class="border-grey-200 group-open:animate-show grid grid-cols-1 gap-24 border-b-2 px-24 py-16 md:grid-cols-2 md:p-40 lg:grid-cols-3"
            >
                @defer (on idle; hydrate on viewport) {
                    @for (contact of department.contacts; track contact) {
                        <ui-m040-c070-contact-person [data]="contact" [isFirstView]="false" />
                    }
                }
            </div>
        </details>
    }
</div>
